import React from 'react'
import { IMediaCard } from '@pcln/contentful-components'
import useContentfulVariation from '@/hooks/useContentfulVariation'
import MediaCardComponent from '@/components/Promos/MediaCard/MediaCardComponent'
import LayoutComponentWrapper from '@/components/LayoutComponentWrapper'
import CONTENT from './content'

export default function IncredibleTile({
  contentFulFieldID,
  useLayout = true
}: {
  contentFulFieldID: 'incredibleTile' | 'incredibleTileMediaCard'
  useLayout?: boolean
}) {
  const promo = useContentfulVariation<IMediaCard>(contentFulFieldID)
  const hasContentfulData = promo != null
  const mediaCardContent = hasContentfulData ? promo : CONTENT

  return useLayout ? (
    <LayoutComponentWrapper>
      <MediaCardComponent content={mediaCardContent} />
    </LayoutComponentWrapper>
  ) : (
    <MediaCardComponent content={mediaCardContent} />
  )
}
